import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ADD_TO_WATCHLIST_STATE_SLICE_KEY, addToWatchlist, } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.reducer';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class AddToWatchlistModalModule {
}
AddToWatchlistModalModule.ɵfac = function AddToWatchlistModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddToWatchlistModalModule)(); };
AddToWatchlistModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AddToWatchlistModalModule });
AddToWatchlistModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IconModule,
        ModalBaseModule,
        FeatureNeededModule,
        LoadingSymbolModule,
        StoreModule.forFeature(ADD_TO_WATCHLIST_STATE_SLICE_KEY, addToWatchlist),
        TooltipModule] });
